/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import skeletonHtml from '../src/skeleton/index.html';
import createId from 'src/utils/createId';
const rootComponent = import('./root.component');
import { DirectionProvider } from '@veneer/core';
import { MfePropsType } from 'src/types/mfeProps';

export default function RootLoader(props: MfePropsType) {
  const [Component, setComponent] = useState<any>();
  const interfaces = window.Shell.v1;

  const directionValue =
    interfaces.localization?.useReactGetLanguageDirection?.(React);

  useEffect(() => {
    rootComponent.then((response) => {
      setComponent(() => response?.default as any);
    });
  }, []);

  return (
    <DirectionProvider direction={directionValue || 'auto'}>
      <div
        style={{ position: 'relative' }}
        data-testid={createId('root-container')}
      >
        <div
          data-testid={createId('skeleton-container')}
          style={{
            position: 'absolute',
            width: '100vw',
            height: '100vh',
            zIndex: -1
          }}
          dangerouslySetInnerHTML={{ __html: skeletonHtml }}
        />
        {Component && <Component {...props} />}
      </div>
    </DirectionProvider>
  );
}
